export default __webpack_public_path__ + "static/media/dinnerFasting.222f71cc.svg";